module.exports = __webpack_public_path__ + "img/user01.d9a37cdc.png";